import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';

const AudioPlayer = ({ audioFile }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef(null);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const onLoadedMetadata = () => {
    setDuration(audioRef.current.duration);
  };

  const onTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
    setProgress((audioRef.current.currentTime / audioRef.current.duration) * 100);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  };

  const handleProgressChange = (event) => {
    const manualChange = Number(event.target.value);
    audioRef.current.currentTime = (manualChange / 100) * duration;
    setProgress(manualChange);
  };

  return (
    <div className="w-full p-4">
      <audio
        ref={audioRef}
        onLoadedMetadata={onLoadedMetadata}
        onTimeUpdate={onTimeUpdate}
      >
        <source
          src={URL.createObjectURL(audioFile)}
          type={audioFile.type}
        />
        Your browser does not support the audio element.
      </audio>

      <div className="flex items-center mb-2">
        <span className="text-sm w-[80px]">{formatTime(currentTime)} / {formatTime(duration)}</span>
        <input
          type="range"
          value={progress}
          onChange={handleProgressChange}
          className="w-full mx-2 cursor-pointer"
        />
        <button
          onClick={togglePlayPause}
          className="ml-2 text-[#242424] p-2 rounded"
        >
          <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
        </button>
      </div>
    </div>
  );
};

export default AudioPlayer;
